// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2g-q";
export var animationRelative = "_2g-p";
export var backdropBlur = "_2g-0";
export var detailLabelCell = "_2g-12";
export var detailTable = "_2g-11";
export var detailValueCell = "_2g-13";
export var docIconBox = "_2g-1d";
export var docIconBoxMd = "_2g-1f";
export var docIconBoxSm = "_2g-1e";
export var docTypeRow = "_2g-16";
export var docTypeRowInner = "_2g-17";
export var dropdownMatchDatePicker = "_2g-3";
export var evidenceCardContent = "_2g-1c";
export var fileUploadSpin = "_2g-j";
export var gorgiasOpenButton = "_2g-15 _2g-d";
export var gorgiasTicketCard = "_2g-14";
export var heroModalFooterButton = "_2g-18";
export var hiddenContainer = "_2g-o";
export var iconPrimary = "_2g-1g";
export var iconSecondary = "_2g-1h";
export var iconTertiary = "_2g-1i";
export var integrationCard = "_2g-1";
export var integrationLogoBox = "_2g-2";
export var mainColumnSticky = "_2g-1b";
export var maxWidthContainer = "_2g-19";
export var modalContentBody = "_2g-a";
export var modalHeaderImage = "_2g-5";
export var modalImageLabel = "_2g-7";
export var modalImageOverlay = "_2g-6";
export var modalImageSubtitle = "_2g-9";
export var modalImageTitle = "_2g-8";
export var modalImageWrapper = "_2g-4";
export var modalStickyFooter = "_2g-b";
export var removeButton = "_2g-e";
export var sidebarColumn = "_2g-1a";
export var spinner = "_2g-i";
export var timelineLine = "_2g-y";
export var timelineLineBlack = "_2g-10 _2g-y";
export var timelineLineGray = "_2g-z _2g-y";
export var timelineLineHeight = "_2g-x";
export var tlDotActivate = "_2g-u";
export var tlDotActivateAnim = "_2g-t";
export var tlDotHide = "_2g-s";
export var tlDotHideAnim = "_2g-r";
export var tlLineActivate = "_2g-w";
export var tlLineActivateAnim = "_2g-v";
export var uploadHint = "_2g-n";
export var uploadIconBox = "_2g-k";
export var uploadLabel = "_2g-m";
export var uploadText = "_2g-l";
export var uploadZone = "_2g-f";
export var uploadZoneCursorDefault = "_2g-h";
export var uploadZoneCursorPointer = "_2g-g";
export var uploadedFileRow = "_2g-c";
export var viewButton = "_2g-d";